"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canDeveloperDeleteGame = canDeveloperDeleteGame;
function canDeveloperDeleteGame(submissionStatus, gameStatus) {
    return (gameStatus === 'DRAFT' || // new non-submitted submission
        submissionStatus === 'DRAFT' || // new non-submitted submission
        gameStatus === 'SUBMISSION' || // the usual: game is not even on portal
        submissionStatus === 'BASIC_LAUNCH_MIXED_RESULT' || // the game had a mixed basic launch
        submissionStatus === 'BASIC_LAUNCH_MIXED_RESULT_SYNC_REQUIRED' // the game had a mixed basic launch and the developer  submitted a new build after that
    );
}
